<script lang="ts">
	import { getProjectSelectorModel } from './project-selector-model';
	import { BaseSelect } from '@shared/svelte';
	import BaseButton from '@shared/svelte/lib/components/base/button/base/BaseButton.svelte';
	import t from '$i18n';
	const viewModel = getProjectSelectorModel();

	const { currentProjectId, projects } = viewModel;
</script>

<BaseSelect
	value={$currentProjectId}
	items={$projects}
	on:open={() => viewModel.startProjectsListener()}
	on:change={(event) => viewModel.selectProject(event.detail)}>
	<BaseButton
		slot="append-item"
		block
		label={$t.create_new_project()}
		on:click={() => viewModel.newProject()} />
</BaseSelect>
